<template>
	<div
		class="stacked"
		:class="{
			'stacked--expired': expired,
			'stacked--inactive': inactive && !expired,
		}"
	>
		<button class="stacked__remove" @click="removeBet()">
			<svg
				width="19"
				height="20"
				viewBox="0 0 24 24"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					opacity="1"
					d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
					fill="var(--light-dark-blue)"
				/>
				<path
					d="M13.06 12L15.36 9.7C15.65 9.41 15.65 8.93 15.36 8.64C15.07 8.35 14.59 8.35 14.3 8.64L12 10.94L9.69998 8.64C9.40998 8.35 8.92999 8.35 8.63999 8.64C8.34999 8.93 8.34999 9.41 8.63999 9.7L10.94 12L8.63999 14.3C8.34999 14.59 8.34999 15.07 8.63999 15.36C8.78999 15.51 8.97999 15.58 9.16999 15.58C9.35999 15.58 9.54998 15.51 9.69998 15.36L12 13.06L14.3 15.36C14.45 15.51 14.64 15.58 14.83 15.58C15.02 15.58 15.21 15.51 15.36 15.36C15.65 15.07 15.65 14.59 15.36 14.3L13.06 12Z"
					fill="var(--white)"
				/>
			</svg>
		</button>
		<div class="stacked__details">
			<div class="stacked__row stacked__row--top">
				<span>
					<span class="stacked__display bold">
						<router-link class="stacked__link" :to="getRoute()">{{
							bet.display | toTitleCase
						}}</router-link>
						<span class="stacked__live" v-show="bet.live && !expired">{{
							this.$t("nav.live")
						}}</span>
					</span>
				</span>
			</div>

			<div class="stacked__row stacked__market">
				<span>{{ bet.market }}</span> •
				<span class="stacked__row stacked__market--odd"
					>{{ bet.odd.odd_key }} {{ getSpecialBetValue() }}</span
				>
			</div>
			<div class="stacked__row stacked__row--bottom">
				<cashout-match-indicator
					:sportID="Number(bet.odd.sport_id)"
					:subTypeID="Number(bet.sub_type_id)"
				/>
				<div>
					<span
						v-if="!bet.live && !expired"
						class="stacked__marker stacked__marker--starttime"
					>
						<span
							>{{ this.$t("betslip.starts") }} {{ bet.startTime | time }}</span
						>
					</span>
					<span
						style="
							margin: 0 5px;
							background: rgb(224 185 224 / 71%);
							color: #902a90;
							background: rgb(238 230 254);
							color: rgb(155 118 222);
							padding: 1px 4px;
							font-size: var(--font-small);
							font-weight: var(--font-weight-medium);
						"
						v-show="bet.is_esport"
						>esport</span
					>
					<span
						class="stacked__marker stacked__marker--changed"
						v-if="bet.changed && !expired"
						>{{ $t("betslip.odd-has-changed") }}</span
					>
					<span
						class="stacked__marker stacked__marker--expired"
						v-if="inactive && !expired"
						>{{ $t("betslip.locked") }}</span
					>
				</div>
			</div>
		</div>
		<div class="stacked__odd">
			<span class="stacked__odd__value bold" v-if="!inactive && !expired">{{
				bet.odd.odd_value
			}}</span>
			<span v-else class="stacked__odd__value bold expired">{{
				expiredLabel
			}}</span>
		</div>
		<span
			class="underline_slip"
			:class="{
				'd-none': keyValue === 1,
			}"
		></span>
	</div>
</template>

<script>
import CashoutMatchIndicator from "../Shared/CashoutMatchIndicator.vue";
export default {
	name: "bet",
	props: ["bet", "currentTime", "keyValue"],
	components: { CashoutMatchIndicator },
	computed: {
		expired() {
			let vm = this;

			let formattedTime = vm.$options.filters.timeZoneTimeStamp(
				vm.bet.startTime
			);

			if(vm.bet.live){
				return !vm.bet.active;
			}else{
				return vm.prematchExpired || new Date(formattedTime) < vm.currentTime;
			}
		},
		prematchExpired(){
			let vm = this;
			return !vm.bet.live && vm.bet.status == "STOPPED";
		},
		inactive() {
			return this.bet.live
				? this.bet.status == "STOPPED" || !Number(this.bet.odd.odd_value)
				: false;
		},
		expiredLabel(){
			let vm = this;
			if(vm.bet.live || vm.prematchExpired){
				return vm.$t("promotions.expired");
			}else{
				return vm.$t("prebets.started");
			}
		}
	},
	methods: {
		removeBet() {
			this.$store.commit("removeFromBetslip", this.bet);
			this.$store.dispatch(
				"recommendations/removeAddedRecommendations",
				this.bet
			);
		},
		getSpecialBetValue() {
			let index = this.bet.odd.special_bet_value
				.split("|")
				.findIndex((x) => x.split("=")[0] == "score");
			return index > -1
				? `(${this.bet.odd.special_bet_value.split("|")[index].split("=")[1]})`
				: "";
		},
		getRoute() {
			return this.bet.live
				? `/live/m/${this.bet.matchId}`
				: `/m/${this.bet.parent_match_id}`;
		},
	},
};
</script>
